import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const LINE_LOOP_PATTERN: SkillCastPattern = (range: number) => {
  return {
    [Direction.N]: Array.from({ length: range * 2 }, (_, i) => [
      0,
      i >= range ? range - (i - range) : i + 1,
      true,
    ]),
    [Direction.NE]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? range - (i - range) : i + 1,
      i >= range ? range - (i - range) : i + 1,
      true,
    ]),
    [Direction.E]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? range - (i - range) : i + 1,
      0,
      true,
    ]),
    [Direction.SE]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? range - (i - range) : i + 1,
      i >= range ? range - (i - range) : i + 1,
      true,
    ]),
    [Direction.S]: Array.from({ length: range * 2 }, (_, i) => [
      0,
      i >= range ? range - (i - range) : i + 1,
      true,
    ]),
    [Direction.SW]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? -1 * range - (i - range) : -i - 1,
      0,
      true,
    ]),
    [Direction.W]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? -1 * range - (i - range) : -i - 1,
      0,
      true,
    ]),
    [Direction.NW]: Array.from({ length: range * 2 }, (_, i) => [
      i >= range ? -1 * range - (i - range) : -i - 1,
      i >= range ? -1 * range - (i - range) : -i - 1,
      true,
    ]),
  };
};
